import { createSlice } from '@reduxjs/toolkit'

export const ReviewWorkFlowSlice = createSlice({
  name: 'edit_review_workflow',
  initialState: {
    value: false,
},
  reducers: {
    updateReviewWorkflow: (state, action) => {
      state.value = action.payload
    }
},
})

export const { updateReviewWorkflow } = ReviewWorkFlowSlice.actions


export default ReviewWorkFlowSlice.reducer